// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// 引入移动端框架Mint
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
import router from './router'

// 引入element-ui框架
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// vuex
import store from './vuex/index.js'

// 自定义插件库封装常用方法
import Plugin from './assets/plugin/index.js'
Vue.use(Plugin)

// 动态修改title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

//复制内容到粘贴板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 打印机
import Print from 'vue-print-nb'
Vue.use(Print)

//cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
// 引入公共样式
import './assets/css/reset.css'

//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);
import 'swiper/swiper-bundle.css'

Vue.config.productionTip = false


Vue.use(Mint);

//moment
import moment from 'moment'
moment.locale('zh-cn');
Vue.prototype.$moment = moment;

import VForm from 'vform-builds'  //引入VForm库
import 'vform-builds/dist/VFormDesigner.css'  //引入VForm样式
Vue.use(VForm)

import Pagination from './components/Pagination'
Vue.use(Pagination)


router.beforeEach((to, from, next) => {
  const { meta, name, query } = to
  const { isMobile } = meta
  if (!isMobile && /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    let ruleA = new Map([['order_type', { query: 'order_type', default: 1 }], ['index', { query: 'list_type', default: 0 }]])
    let ruleB = new Map([['type', { query: 'list_type', default: 0 }]])
    const same = true
    let m = new Map([
      ['activityTemplate', { path: "mactivity", same }], //活动模板
      ['goodsDetail', { path: "mGoodsDetail", same }], //商品详情页
      ['goodsActivityDetail', { path: "mpromotionDetail", same }], //活动商品详情页
      ['brandDetail', { path: "mbrandDetail", same}], //品牌详情页
      ['mineOrder', { path: "morder", rule: ruleA }], //活动订单
      ['mineOrderActive', { path: "morder", rule: ruleA }], //活动订单
      ['mineOrderTeam', { path: "morderTeam", rule: ruleB }], //团购订单
      ['mineInvoice', { path: "minvoice" }], //发票管理
      ['mineAddress', { path: "maddressList" }], //地址、客户地址
      ['mineAccount', { path: "maccount" }], //我的账户
      ['mineBill', { path: "mbill" }], //对账单
      ['mineDiscount', { path: "mcoupon" }], //我的优惠券
      ['discountCenter', { path: "mcouponAll" }], //优惠券中心
      ['mineCollect', { path: "mfav" }], //收藏夹
      ['mineNeed', { path: "mneeds" }], //需求登记
      ['mineFootprint', { path: "mhistroy" }], //浏览记录
      ['integralMall', { path: "mintegralGoodsDetail", same }], //浏览记录
      ['mineScoreOrder', { path: "mintegralList" }], //积分订单
      ['mineCloudStorage', { path: "mcloudStorage" }], //云仓订单
      ['mineTeamOrderDetail', { path: "morderDetail", same }], //订单
      ['mineBuyBill', { path: "mpurchaseOrders" }], //订单
      ['questionnaire', { path: "mquestionnaire", same }], //调查问卷
    ]);
    if (m.get(name)) {
      const { path, rule, same } = m.get(name)
      let newQuery = {}
      if (same) {
        newQuery = { ...query }
      } else if (rule) {
        for (let [k, q] of rule) {
          newQuery[q.query] = q.default
        }
        for (let k in query) {
          rule.get(k) ? newQuery[rule.get(k).query] = query[k] : ''
        }
      }
      next({ path, query: newQuery })
    } else {
      next({ path: 'mhome' })
    }
  } else {
    next()
  }
})

router.afterEach((to, from, next) => {
  //百度统计代码
  setTimeout(() => {
      // var _hmt = _hmt || [];
      // (function() {
      // var hm = document.createElement("script");
      // hm.src = "https://hm.baidu.com/hm.js?323fa261ce8eb6f91a952162b08e5c4d";
      // var s = document.getElementsByTagName("script")[0];
      // s.parentNode.insertBefore(hm, s);
      // })();
    (function () {
      const isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
      const body = document.querySelectorAll("body")[0]
      const qidianId = 'qd30090716498c65ee427d030609b4d00f9bce0ee179'
      const removeSupportScripts = () => {
        ;['baidu_tj', qidianId].forEach(id => {
          document.getElementById(id) && document.getElementById(id).remove()
        })
        ;[].slice.call(document.querySelectorAll('script')).forEach(script => {
          const src = script.getAttribute('src') || ''
          const isSupportScript = src.indexOf('hm.baidu.com/hm.js') > -1 || src.indexOf('wp.qiye.qq.com/qidian/') > -1
          if (isSupportScript) {
            script.parentNode && script.parentNode.removeChild(script)
          }
        })
      }

      if (isMobile) {
        body.setAttribute("class", "mobile_css")
        removeSupportScripts()
        return
      } else {
        body.setAttribute("class","")
      }

      // 百度客服，关闭注释下面一段
      if (!window.__PRERENDER_INJECTED) {
        removeSupportScripts()
        let hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?323fa261ce8eb6f91a952162b08e5c4d";
        hm.id = "baidu_tj"
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);

        let hm2 = document.createElement("script");
        hm2.src = "https://wp.qiye.qq.com/qidian/3009071649/8c65ee427d030609b4d00f9bce0ee179";
        s.parentNode.insertBefore(hm2, s);
      }

    })();
  }, 0);
});


/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>',
  mounted() {
    // prerender-trigger 已移至各页面数据加载完成后单独触发
    // 请勿在此处统一触发，否则异步数据尚未返回即被截图
  }
})



// WEBPACK FOOTER //
// ./src/main.js